import { render } from "./DiagnosticsIcon.vue?vue&type=template&id=2ec206e4"
const script = {}

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__